import type { HealthFeatureConfig } from '../../../types/insurances/HealthFeatureConfig';

export const health: HealthFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            showContractNumber: true,
            showContractHolder: true,
            fallbackAssistancePhonesKey: 'HR',
            fallbackAssistanceEmailsKey: 'HR',
            showCard: false,
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
